/* eslint-disable no-useless-escape */
const checkEmail = (email) => {
	return /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+(\.[a-zA-Z]{2,})+$/.test(email);
};
const formatEmail = (email) => {
	return email.toLowerCase();
};

export default checkEmail;
export { formatEmail };
